import { render, staticRenderFns } from "./passdaten-konfiguration-section.vue?vue&type=template&id=21a92fd2&scoped=true"
import script from "./passdaten-konfiguration-section.vue?vue&type=script&lang=js"
export * from "./passdaten-konfiguration-section.vue?vue&type=script&lang=js"
import style0 from "./passdaten-konfiguration-section.vue?vue&type=style&index=0&id=21a92fd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a92fd2",
  null
  
)

export default component.exports